import Controller, { OnAfterFetch, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ActionAPI, ToastNotificationAPI } from '@philips-internal/oswald-ui-components';
import { ClickEvent, FetchEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Inject } from '@odinjs/odin';

import BaseController from '../BaseController';
import { TasksUtils } from '../../utils/tasks-utils';
import TASK_STATUS from '../../constants/task-status';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { FragmentNames, InstitutionalMaterialAliases } from '../../codegen';
import { DYNAMIC_STEP_IDENTIFIER } from './tasks-controller';

import './institutional-material-controller.css';
import TaskItem from '../../interfaces/task-item';

interface InstitutionalMaterialData {
  dsConteudo: string;
  dsTitulo: string;
  ieStatusTarefa: string;
  nrSequencia: number;
}

@Controller({ component: InstitutionalMaterialAliases.INSTITUTIONAL_MATERIAL_LAYOUT, fragment: FragmentNames.INSTITUTIONAL_MATERIAL })
class InstitutionalMaterialController extends BaseController {

  disableCheckAction = true;

  @Inject(InstitutionalMaterialAliases.INSTITUTIONAL_MATERIAL_CHECK_ACTION)
    institutionalMaterialCheckActionApi!: ActionAPI;

  @Inject(InstitutionalMaterialAliases.TOAST_NOTIFICATION)
    toastNotificationBlockMessageApi!: ToastNotificationAPI;

  @OnMount(InstitutionalMaterialAliases.INSTITUTIONAL_MATERIAL_CHECK_ACTION)
  onMountAction(event: MountEvent): void {
    const checkActionAPI = event.target as ActionAPI;
    const identifier = this.context.get('identifier') as string;
    const nrSequencia = identifier.split(DYNAMIC_STEP_IDENTIFIER.INSTITUTIONAL_MATERIAL.concat('-'))[1];
    this.context.set({ nrSequencia });

    this.setInitialActionStatus(checkActionAPI, nrSequencia);
  }

  private setInitialActionStatus(checkActionAPI: ActionAPI, taskSequence: string): void {
    const taskList = this.context.get('taskList') as TaskItem[];
    const materialInstitutionalTask = taskList.find(task => task.nrSequencia === Number(taskSequence));

    if (materialInstitutionalTask){
      TasksUtils.setInitialActionStatus({
        checkActionAPI,
        onBlocked: () => this.toastNotificationBlockMessageApi.setVisible(true),
        taskItem: materialInstitutionalTask,
      });
    }
  }

  @OnAfterFetch(InstitutionalMaterialAliases.INSTITUTIONAL_MATERIAL_FETCH)
  onAfterFetch(event: FetchEvent): void {
    const instMatdata = event.data as InstitutionalMaterialData;

    if (!instMatdata) return;

    if (instMatdata.ieStatusTarefa === TASK_STATUS.PENDING) {
      this.disableCheckAction = false;
    } else {
      const identifier = this.context.get('identifier') as string;

      TasksUtils.setActionChecked(this.institutionalMaterialCheckActionApi, identifier)
      this.disableCheckAction = true;
    }
  }

  @OnClick(InstitutionalMaterialAliases.INSTITUTIONAL_MATERIAL_CHECK_ACTION)
  onClickCheckAction(event: ClickEvent): void {
    if (this.disableCheckAction) return;

    const checkAction = event.target as ActionAPI;
    const nrSequencia = this.context.get('nrSequencia');
    const identifier = this.context.get('identifier') as string;

    HttpService.put(APPLICATION_ENDPOINTS.UPDATE_TASK_STATUS, { nrSequencia }).then(() => {
      TasksUtils.setActionChecked(checkAction, identifier);
      this.disableCheckAction = true;
    });
  }
}

export default InstitutionalMaterialController;
